import React from 'react';
import { Box, InputAdornment, Typography } from '@mui/material';
import { BaseTextField } from '../../../Inputs';
import { Button } from '../../../Button';
import { ClickToCopy } from '../../../ClickToCopy';


const InstructionLine: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography component="p" sx={{ mb: 2 }}>
    {children}
  </Typography>
);


export const InstructionGoogleCalendar: React.FC<{ icsLink: string }> = ({ icsLink }) => {
  return (
    <Box>
      <InstructionLine>
        <Box mb={1}>
          <strong>Copy subscription URL:</strong>
        </Box>
        <BaseTextField
          fullWidth value={icsLink} color="secondary" size="small"
          slotProps={{
            input: {
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <ClickToCopy text={icsLink} />
                </InputAdornment>
              )
            }
          }}
        />
      </InstructionLine>
      <InstructionLine><strong>Open Google Calendar:</strong> On your computer, go to <a href="https://calendar.google.com" target="_blank" rel="noreferrer">calendar.google.com</a> and sign in to your Google account.</InstructionLine>
      <InstructionLine><strong>Locate "Other calendars":</strong> On the left-hand side of the screen, find the "Other calendars" section.</InstructionLine>
      <InstructionLine><strong>Add a new calendar:</strong> Click the plus sign (+) next to "Other calendars".</InstructionLine>
      <InstructionLine><strong>Select "From URL":</strong> From the menu that appears, select "From URL".</InstructionLine>
      <InstructionLine><strong>Enter the URL:</strong> In the "URL of Calendar" field, paste the .ics link you obtained in step 1.</InstructionLine>
      <InstructionLine><strong>Add the calendar:</strong> Click the "Add calendar" button.</InstructionLine>
    </Box>
  );
};


export const InstructionAppleCalendar: React.FC<{ icsLink: string }> = ({ icsLink }) => {
  return (
    <Box>
      <InstructionLine>
        <Box mb={1}>
          <strong>Copy subscription URL:</strong>
        </Box>
        <BaseTextField
          fullWidth value={icsLink} color="secondary" size="small"
          slotProps={{
            input: {
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <ClickToCopy text={icsLink} />
                </InputAdornment>
              )
            }
          }}
        />
      </InstructionLine>
      <InstructionLine><strong>Open Apple Calendar:</strong> On your Mac, open the Calendar app.</InstructionLine>
      <InstructionLine><strong>Go to "File" Menu:</strong> In the top menu bar, click on "File".</InstructionLine>
      <InstructionLine><strong>Select "New Calendar Subscription":</strong> From the dropdown menu, select "New Calendar Subscription".</InstructionLine>
      <InstructionLine><strong>Enter the URL:</strong> In the dialog box that appears, paste the .ics link you obtained in step 1 into the "Calendar URL" field.</InstructionLine>
      <InstructionLine><strong>Subscribe:</strong> Click the "Subscribe" button.</InstructionLine>
      <InstructionLine><strong>Adjust settings:</strong> In the next dialog, you can customize the calendar's name, color, and update frequency.</InstructionLine>
      <InstructionLine><strong>Adjust Auto-refresh:</strong> Change Auto-Refresh option to "Every Day" or less, to have your sessions synced frequent enough to not miss it.</InstructionLine>
      <InstructionLine><strong>Confirm subscription:</strong> Once done, click "OK".</InstructionLine>
    </Box>
  );
};

export const InstructionNativeCalendarWithLinkButton: React.FC<{ icsLink: string }> = ({ icsLink }) => {
  return (
    <Box>
      <InstructionLine>
        <Box mb={1}>
          Press the button below, and it will open your native calendar application to subscribe to the calendar.
        </Box>
      </InstructionLine>
      <Button fullWidth variant="contained" color="secondary" component="a" href={icsLink}>Subscribe to calendar</Button>
    </Box>
  );
};
